export const evDate = (e) => e.date_label || e.display_date || `Year ${e.timestamp_int}`;
